<script setup lang="ts">
/**
 * RinganLencana — padanan <CaBadge> tanpa Nuxt UI.
 *
 * CaBadge membungkus <UBadge>, tapi seluruh kelas bawaan UBadge sudah ditimpa
 * habis oleh `ui.base` milik CaBadge (terbukti di HTML hasil build: yang
 * tersisa hanya kelas kita sendiri). Jadi library-nya menanggung nol tampilan
 * di sini — ia hanya ikut terbawa ke bundel. Elemen <span> biasa memberi hasil
 * yang sama persis.
 *
 * Peta `tone` disalin apa adanya dari CaBadge, termasuk aturan warnanya:
 * gold cerah HANYA boleh jadi LATAR (tinta gelap di atasnya = 11,6:1).
 * Jangan pernah dibalik jadi teks gold di atas putih — 1,66:1, gagal total.
 */
withDefaults(
  defineProps<{
    tone?: 'brand' | 'ok' | 'warn' | 'bad' | 'netral' | 'emas' | 'emas-lembut'
    icon?: string
  }>(),
  { tone: 'netral' }
)

const kelasTone: Record<string, string> = {
  brand: 'bg-brand text-brand-fg',
  ok: 'bg-ok-soft text-ok',
  warn: 'bg-warn-soft text-warn',
  bad: 'bg-bad-soft text-bad',
  netral: 'bg-surface-2 text-muted border border-line',
  emas: 'bg-[var(--ca-cta-bg)] text-[var(--ca-cta-fg)]',
  'emas-lembut': 'bg-brand-soft text-brand border border-brand/30'
}
</script>

<template>
  <span
    class="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold leading-none"
    :class="kelasTone[tone]"
  >
    <RinganIkon v-if="icon" :nama="icon" class="size-3.5 shrink-0" />
    <slot />
  </span>
</template>
